module.exports = __webpack_public_path__ + "img/cards.14494f7.png";